(function () {
  'use strict';

  function q(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function semanticProductAlt(color, material, title) {
    var productTitle = String(title || 'Monvane modular couch').trim();
    var parts = [];
    if (color) parts.push(String(color).trim());
    if (material && productTitle.toLowerCase().indexOf(String(material).toLowerCase()) === -1) {
      parts.push(String(material).trim());
    }
    parts.push(productTitle);
    if (productTitle.toLowerCase().indexOf('monvane') === -1) parts.push('by Monvane');
    return parts.filter(Boolean).join(' ');
  }

  function syncVariantUrl(variantId) {
    if (!variantId || !window.history || typeof window.history.replaceState !== 'function') return;
    var target = new URL(window.location.href);
    target.searchParams.set('variant', String(variantId));
    window.history.replaceState(window.history.state, '', target.pathname + target.search + target.hash);
  }

  function formatMoney(cents, format) {
    var value = Number(cents);
    if (!Number.isFinite(value)) return '';
    var template = format || '${{amount}}';
    var match = template.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return (value / 100).toFixed(2);

    var token = match[1];
    var decimals = token.indexOf('no_decimals') !== -1 ? 0 : 2;
    var decimalMark = token.indexOf('comma_separator') !== -1 ? ',' : '.';
    var thousandsMark = token.indexOf('comma_separator') !== -1 ? '.' : ',';
    var amount = (value / 100).toFixed(decimals).split('.');
    amount[0] = amount[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsMark);
    return template.replace(match[0], amount[0] + (decimals ? decimalMark + amount[1] : ''));
  }

  function updateAddCartPrice() {
    var select = q('.cubeflex-variant-select');
    var addPrice = q('[data-add-cart-price]');
    if (!select || !addPrice) return;
    var option = select.options[select.selectedIndex];
    if (!option) return;
    var cents = parseInt(option.getAttribute('data-price-cents'), 10);
    var quantityInput = q('.quantity-control input[name="quantity"]');
    var quantity = Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);
    if (Number.isFinite(cents)) {
      addPrice.textContent = formatMoney(cents * quantity, addPrice.getAttribute('data-money-format'));
    } else {
      addPrice.textContent = option.getAttribute('data-price') || '';
    }
  }

  function updateAffirmPrice() {
    var select = q('.cubeflex-variant-select');
    var message = q('[data-cubeflex-affirm] .affirm-as-low-as');
    if (!select || !message) return;
    var option = select.options[select.selectedIndex];
    if (!option) return;
    var cents = parseInt(option.getAttribute('data-price-cents'), 10);
    if (!Number.isFinite(cents)) return;
    message.setAttribute('data-amount', String(cents));
    if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === 'function') {
      window.affirm.ui.refresh();
    }
  }

  function replaceOptionButtons(blockSelector, items, selectedValue, material) {
    var block = q(blockSelector);
    if (!block || !Array.isArray(items)) return;
    var container = q(material ? '.fabric-grid' : '.swatches', block);
    if (!container) return;
    if (material) {
      // Keep the selected value for variant matching, but hide redundant controls.
      block.hidden = items.length < 2;
      var divider = block.previousElementSibling;
      if (divider && divider.hasAttribute('data-material-divider')) divider.hidden = block.hidden;
    }
    container.innerHTML = '';
    items.forEach(function (item) {
      var button = document.createElement('button');
      var selected = item.value === selectedValue;
      button.type = 'button';
      button.className = material ? 'fabric' + (selected ? ' active' : '') : (selected ? 'selected' : '');
      button.setAttribute('data-option-index', material ? '2' : '1');
      button.setAttribute('data-value', item.value || '');
      button.setAttribute('aria-label', material ? 'Select ' + item.value : item.value);
      button.setAttribute('aria-pressed', String(selected));
      if (item.swatchImage) {
        var image = document.createElement('img');
        image.alt = material ? item.value + ' texture' : '';
        image.src = item.swatchImage;
        button.appendChild(image);
      } else {
        var swatch = document.createElement('span');
        swatch.className = 'swatch-fallback';
        swatch.style.background = item.swatchColor || '#8a8f8a';
        button.appendChild(swatch);
      }
      container.appendChild(button);
    });
    var title = q('[data-option-title]', block);
    if (title) title.textContent = selectedValue || (items[0] && items[0].value) || '';
  }

  function rebuildProductOptions(payload) {
    replaceOptionButtons('.color-option', payload.colors, payload.selected && payload.selected.color, false);
    replaceOptionButtons('.material-option', payload.materials, payload.selected && payload.selected.material, true);
  }

  var gallery = {
    stage: null,
    main: null,
    thumbs: [],
    current: 0,

    init: function () {
      this.stage = q('.gallery-stage');
      if (!this.stage) return;
      this.current = 0;
      this.main = q('.main-image img', this.stage);
      this.refresh();
      var self = this;
      var left = q('.thumbnail-arrow--left', this.stage);
      var right = q('.thumbnail-arrow--right', this.stage);
      if (left) left.addEventListener('click', function () { self.step(-1); });
      if (right) right.addEventListener('click', function () { self.step(1); });
    },

    refresh: function () {
      this.thumbs = qa('.thumbnail-strip button', this.stage);
      var self = this;
      this.thumbs.forEach(function (btn, idx) {
        btn.addEventListener('click', function () { self.setActive(idx); });
      });
    },

    step: function (delta) {
      this.setActive(this.current + delta);
    },

    setActive: function (i) {
      if (!this.thumbs.length) return;
      this.current = (i + this.thumbs.length) % this.thumbs.length;
      this.thumbs.forEach(function (btn, idx) {
        btn.classList.toggle('active', idx === gallery.current);
        btn.setAttribute('aria-pressed', String(idx === gallery.current));
      });
      var img = q('img', this.thumbs[this.current]);
      var src = this.thumbs[this.current].getAttribute('data-full-src') || (img && img.getAttribute('src'));
      if (this.main && src) {
        this.main.setAttribute('src', src);
        this.main.classList.add('is-loaded');
      }
      if (this.thumbs[this.current] && this.thumbs[this.current].scrollIntoView) {
        this.thumbs[this.current].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    },

    setImages: function (list) {
      var strip = q('.thumbnail-strip', this.stage);
      if (!strip) return;
      strip.innerHTML = '';
      list.forEach(function (src, idx) {
        var btn = document.createElement('button');
        if (idx === 0) btn.className = 'active';
        btn.setAttribute('aria-label', 'View product image ' + (idx + 1));
        btn.setAttribute('aria-pressed', String(idx === 0));
        btn.setAttribute('data-full-src', src);
        var img = document.createElement('img');
        img.alt = '';
        img.src = src;
        btn.appendChild(img);
        strip.appendChild(btn);
      });
      this.current = 0;
      this.refresh();
      if (this.main && list[0]) {
        this.main.setAttribute('src', list[0]);
        this.main.classList.add('is-loaded');
      }
    }
  };

  function initOptions() {
    var select = q('.cubeflex-variant-select');
    var priceEl = q('[data-price-wrapper] [data-price]');
    var compareEl = q('[data-price-wrapper] [data-compare-price]');
    var saveBadge = q('[data-price-wrapper] [data-save-badge]');
    var addPrice = q('[data-add-cart-price]');
    var mainWrap = q('.main-image');

    var LAYOUT_CLASSES = {
      '2 Seater': 'two',
      'Chaise Sofa': 'chaise-left',
      'Corner Sofa': 'chaise-right',
      'Lounge Sofa': 'lounge',
      'Extended Lounge': 'extended',
      'Grand Lounge': 'grand'
    };

    function readColorGallery() {
      var mapEl = q('#cubeflex-gallery-map');
      if (!mapEl) return {};
      try { return JSON.parse(mapEl.textContent); } catch (e) { return {}; }
    }
    var colorGallery = readColorGallery();
    var hasExplicitConfiguration = new URLSearchParams(window.location.search).has('cf_config');

    function configurationUrl(url) {
      var target = new URL(url, window.location.origin);
      target.searchParams.set('view', 'cubeflex-1');
      target.searchParams.set('cf_config', '1');
      var previewTheme = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (previewTheme) target.searchParams.set('preview_theme_id', previewTheme);
      return target.pathname + target.search + target.hash;
    }

    function selectedValues() {
      var vals = ['', '', ''];
      qa('.option-block').forEach(function (block) {
        var btn = q('button.selected, button.active', block);
        if (btn) {
          var idx = parseInt(btn.getAttribute('data-option-index'), 10);
          vals[idx] = btn.getAttribute('data-value');
        }
      });
      return vals;
    }

    function applyVariant() {
      if (!select) return;
      var vals = selectedValues();
      var target = null;
      qa('option', select).forEach(function (o) {
        if (
          o.getAttribute('data-option1') === vals[1] &&
          o.getAttribute('data-option2') === vals[2]
        ) {
          target = o;
        }
      });
      if (!target) return;
      select.value = target.value;
      syncVariantUrl(target.value);
      if (priceEl) priceEl.textContent = target.getAttribute('data-price');
      updateAddCartPrice();
      updateAffirmPrice();
      var priceCents = Number(target.getAttribute('data-price-cents'));
      var compareCents = Number(target.getAttribute('data-compare-at-price-cents'));
      var hasDiscount = compareCents > priceCents && priceCents >= 0;
      if (compareEl) {
        compareEl.textContent = hasDiscount ? target.getAttribute('data-compare-at-price') : '';
        compareEl.hidden = !hasDiscount;
      }
      if (saveBadge) {
        var percent = hasDiscount ? Math.round((compareCents - priceCents) * 100 / compareCents) : 0;
        saveBadge.textContent = percent > 0 ? 'Save ' + percent + '%' : '';
        saveBadge.hidden = percent <= 0;
      }
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function applyImage() {
      var vals = selectedValues();
      var color = vals[1] || 'Dark Grey';
      var material = vals[2] || '';
      var list = colorGallery[color];
      if (list && list.length) gallery.setImages(list);
      var productTitle = q('#product-title');
      if (gallery.main) gallery.main.alt = semanticProductAlt(color, material, productTitle && productTitle.textContent);
      var configBtn = q('.config-option button.selected');
      var layoutKey = configBtn ? configBtn.getAttribute('data-layout-key') : vals[0];
      var layoutClass = LAYOUT_CLASSES[layoutKey] || 'chaise-right';
      if (mainWrap) {
        mainWrap.classList.remove(
          'product-image-two',
          'product-image-chaise-left',
          'product-image-chaise-right',
          'product-image-lounge',
          'product-image-extended',
          'product-image-grand'
        );
        mainWrap.classList.add('product-image-' + layoutClass);
      }
    }

    function setInitialOption(blockSelector, value, activeClass) {
      var block = q(blockSelector);
      if (!block) return;
      var buttons = qa('button', block);
      var target = null;
      buttons.forEach(function (btn) {
        if (btn.getAttribute('data-value') === value || btn.getAttribute('data-layout-key') === value) target = btn;
      });
      if (!target) return;
      buttons.forEach(function (btn) {
        btn.classList.remove('selected', 'active');
        btn.setAttribute('aria-pressed', 'false');
      });
      target.classList.add('selected');
      if (activeClass) target.classList.add(activeClass);
      target.setAttribute('aria-pressed', 'true');
      var title = q('[data-option-title]', block);
      if (title) title.textContent = target.getAttribute('data-value') || target.getAttribute('aria-label') || value;
    }

    function applyInitialDefaults() {
      var selectedOption = select && select.options[select.selectedIndex];
      var initialColor = selectedOption && selectedOption.getAttribute('data-option1') || 'Dark Grey';
      var initialMaterial = selectedOption && selectedOption.getAttribute('data-option2') || 'Chenille';
      setInitialOption('.color-option', initialColor);
      setInitialOption('.material-option', initialMaterial, 'active');
    }

    function updateAvailability() {
      if (!select) return;
      var vals = selectedValues();
      var material = vals[2];
      var colorButtons = qa('.color-option button[data-option-index="1"]');
      if (!colorButtons.length) return;
      var available = {};
      qa('option', select).forEach(function (o) {
        if (o.getAttribute('data-option2') === material) {
          available[o.getAttribute('data-option1')] = true;
        }
      });
      colorButtons.forEach(function (btn) {
        var ok = !!available[btn.getAttribute('data-value')];
        btn.classList.toggle('is-unavailable', !ok);
      });
      var current = q('.color-option button.selected');
      if (current && current.classList.contains('is-unavailable')) {
        current.classList.remove('selected');
        current.setAttribute('aria-pressed', 'false');
        var first = null;
        for (var i = 0; i < colorButtons.length; i++) {
          if (!colorButtons[i].classList.contains('is-unavailable')) { first = colorButtons[i]; break; }
        }
        if (first) {
          first.classList.add('selected');
          first.setAttribute('aria-pressed', 'true');
          var title = q('.color-option [data-option-title]');
          if (title) title.textContent = first.getAttribute('data-value');
        }
      }
    }

    function bindOptionButtons() {
      qa('.option-block').forEach(function (block) {
        var title = q('[data-option-title]', block);
        var buttons = qa('button', block);
        buttons.forEach(function (btn) {
          if (btn.getAttribute('data-cubeflex-bound') === 'true') return;
          btn.setAttribute('data-cubeflex-bound', 'true');
        btn.addEventListener('click', function (e) {
          if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
          var configUrl = btn.getAttribute('data-config-url');
          buttons.forEach(function (b) {
            b.classList.remove('selected', 'active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('selected', 'active');
          btn.setAttribute('aria-pressed', 'true');
          var label = btn.getAttribute('data-value') || btn.getAttribute('aria-label') || btn.textContent.trim();
          if (title) title.textContent = label;
          if (configUrl) {
            if (e) e.preventDefault();
            navigateProduct(configUrl);
            return;
          }
          updateAvailability();
          applyVariant();
          applyImage();
        });
        });
      });
    }
    function refreshOptions() {
      colorGallery = readColorGallery();
      bindOptionButtons();
      updateAvailability();
      applyVariant();
      applyImage();
    }

    window.__cubeflexRefreshOptions = refreshOptions;
    bindOptionButtons();
    applyInitialDefaults();
    refreshOptions();
  }

  function initQuantity() {
    var root = q('.quantity-control');
    if (!root) return;
    var out = q('span', root);
    var input = q('input', root);
    function set(n) {
      n = Math.max(1, Math.min(99, n));
      if (out) out.textContent = String(n);
      if (input) input.value = String(n);
      updateAddCartPrice();
    }
    qa('button', root).forEach(function (btn, idx) {
      btn.addEventListener('click', function () {
        var cur = parseInt((out && out.textContent) || '1', 10) || 1;
        set(idx === 0 ? cur - 1 : cur + 1);
      });
    });
  }

  function initRecommendations() {
    var root = q('.recommendation-carousel');
    if (!root) return;
    var cards = q('.product-cards', root);
    var prev = q('.recommendation-arrow--previous', root);
    var next = q('.recommendation-arrow--next', root);
    if (!cards) return;
    function updateRecommendationArrows() {
      var max = cards.scrollWidth - cards.clientWidth;
      if (prev) prev.disabled = cards.scrollLeft <= 1;
      if (next) next.disabled = cards.scrollLeft >= max - 1;
    }
    if (next) next.addEventListener('click', function () { cards.scrollBy({ left: cards.clientWidth, behavior: 'smooth' }); });
    if (prev) prev.addEventListener('click', function () { cards.scrollBy({ left: -cards.clientWidth, behavior: 'smooth' }); });
    cards.addEventListener('scroll', updateRecommendationArrows, { passive: true });
    updateRecommendationArrows();
  }

  function initReviews() {
    var tabs = qa('.review-tabs button');
    var reviews = q('#reviews-panel');
    var faq = q('#faq-panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        var isFaq = tab.id === 'faq-tab';
        if (reviews) reviews.style.display = isFaq ? 'none' : '';
        if (faq) faq.style.display = isFaq ? '' : 'none';
      });
    });

    var judgeWidget = q('#judgeme_product_reviews');
    if (!judgeWidget) return;
    var judgeSection = judgeWidget.closest('.cfxe-reviews') || judgeWidget.parentElement;

    function cleanImportedReviewMedia(root) {
      qa('.jdgm-rev__body', root).forEach(function (body) {
        var walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT);
        var textNode = walker.nextNode();
        while (textNode) {
          if (textNode.textContent.indexOf('The media could not be loaded.') !== -1) {
            textNode.textContent = textNode.textContent.replace('The media could not be loaded.', '');
          }
          textNode = walker.nextNode();
        }

        var firstParagraph = q('p', body);
        if (firstParagraph && !firstParagraph.textContent.trim()) {
          firstParagraph.remove();
        }

        var contentParagraph = q('p', body);
        while (contentParagraph && contentParagraph.firstChild) {
          var firstNode = contentParagraph.firstChild;
          if (firstNode.nodeType === 3 && !firstNode.textContent.trim()) {
            firstNode.remove();
          } else if (firstNode.nodeName === 'BR') {
            firstNode.remove();
          } else {
            break;
          }
        }
      });

      qa('.jdgm-rev__pic-img[data-src]', root).forEach(function (image) {
        var source = image.getAttribute('data-src');
        if (!source) return;
        var link = image.closest('.jdgm-rev__pic-link');
        image.loading = 'lazy';
        image.decoding = 'async';
        image.addEventListener('load', function () {
          if (link) link.classList.remove('jdgm--loading');
        }, { once: true });
        image.addEventListener('error', function () {
          if (link) link.style.display = 'none';
        }, { once: true });
        if (link) link.classList.remove('jdgm--loading');
        image.src = source;
        image.removeAttribute('data-src');
        if (image.complete && image.naturalWidth > 0 && link) link.classList.remove('jdgm--loading');
      });
    }

    cleanImportedReviewMedia(judgeSection);
    if (judgeSection && judgeSection.getAttribute('data-cubeflex-media-observer') !== 'true') {
      judgeSection.setAttribute('data-cubeflex-media-observer', 'true');
      new MutationObserver(function () {
        cleanImportedReviewMedia(judgeSection);
      }).observe(judgeSection, { childList: true, subtree: true });
    }
  }

  function initReviewScroll() {
    var trigger = q('[data-cubeflex-review-scroll]');
    if (!trigger || trigger.dataset.reviewScrollReady === 'true') return;
    trigger.dataset.reviewScrollReady = 'true';
    trigger.addEventListener('click', function () {
      var target = q('.cfxe-reviews') || q('#reviews');
      if (!target) return;
      var reviewsTab = q('.cfxe-review-tabs [role="tab"]', target) || q('#reviews-tab');
      if (reviewsTab && reviewsTab.getAttribute('aria-selected') !== 'true') reviewsTab.click();
      window.requestAnimationFrame(function () {
        var header = q('.site-header');
        var offset = (header ? header.getBoundingClientRect().height : 0) + 16;
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    });
  }

  function initReviewPagination() {
    var panel = q('#reviews-panel');
    if (!panel) return;
    var items = qa('article[data-review-page]', panel);
    var dots = qa('.review-dot', panel);
    if (!items.length || !dots.length) return;
    function show(page) {
      var target = String(page);
      items.forEach(function (el) {
        el.style.display = el.getAttribute('data-review-page') === target ? '' : 'none';
      });
      dots.forEach(function (d) {
        var isActive = d.getAttribute('data-review-page') === target;
        d.classList.toggle('active', isActive);
        if (isActive) {
          d.setAttribute('aria-current', 'true');
        } else {
          d.removeAttribute('aria-current');
        }
      });
    }

    function scrollToFirstReview(page) {
      var target = String(page);
      var firstReview = null;
      items.forEach(function (el) {
        if (!firstReview && el.getAttribute('data-review-page') === target) firstReview = el;
      });
      if (!firstReview) return;

      window.requestAnimationFrame(function () {
        var header = q('.site-header');
        var headerOffset = (header ? header.getBoundingClientRect().height : 0) + 20;
        var top = firstReview.getBoundingClientRect().top + window.scrollY - headerOffset;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var page = parseInt(d.getAttribute('data-review-page'), 10);
        show(page);
        scrollToFirstReview(page);
      });
    });
    show(1);
  }

  function initVideo() {
    var hero = q('.video-hero');
    if (!hero) return;
if (hero.dataset.cubeflexVideoInitialized === 'true') return;
hero.dataset.cubeflexVideoInitialized = 'true';

    function hydrateVideo(video) {
      if (video.dataset.cubeflexSourceReady === 'true') return;
      qa('source[data-src]', video).forEach(function (source) {
        source.src = source.getAttribute('data-src');
        source.removeAttribute('data-src');
      });
      video.dataset.cubeflexSourceReady = 'true';
    }

    function startVideo(video) {
      hydrateVideo(video);
      video.muted = true;
      video.loop = true;
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    function startVisibleVideos() {
      qa('video', hero).forEach(function (video) {
        if (window.getComputedStyle(video).display !== 'none') startVideo(video);
      });
    }

    function preloadDesktopVideo() {
      var video = q('.video-hero-desktop', hero);
      if (!video || window.getComputedStyle(video).display === 'none') return;
      video.preload = 'auto';
      hydrateVideo(video);
      video.load();
    }

    function scheduleDesktopPreload() {
      function queuePreload() {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(preloadDesktopVideo, { timeout: 2200 });
        } else {
          window.setTimeout(preloadDesktopVideo, 1200);
        }
      }

      if (document.readyState === 'complete') queuePreload();
      else window.addEventListener('load', queuePreload, { once: true });
    }

    if (!('IntersectionObserver' in window)) {
      startVisibleVideos();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        startVisibleVideos();
        observer.disconnect();
      });
    }, { rootMargin: '900px 0px' });
    observer.observe(hero);
  }

  function initGalleryPin() {
    var media = window.matchMedia('(min-width: 821px)');

    function syncGalleryPin() {
      var stage = q('.gallery-stage');
      var wrap = q('.gallery-sticky-wrap');
      var spacer = q('.gallery-spacer');
      var story = q('.product-story');
      if (!stage || !wrap || !spacer || !story) return;

      if (!media.matches) {
        stage.style.removeProperty('--gallery-pin-top');
        wrap.style.removeProperty('--gallery-pin-extension');
        return;
      }

      var scrollTop = window.scrollY || window.pageYOffset || 0;
      var galleryTop = wrap.getBoundingClientRect().top + scrollTop;
      var storyTop = story.getBoundingClientRect().top + scrollTop;
      var releaseAt = galleryTop + stage.offsetHeight + 110;
      var fixedDistance = Math.max(0, storyTop - releaseAt);
      var extension = Math.max(0, fixedDistance - spacer.offsetHeight);

      stage.style.setProperty('--gallery-pin-top', Math.round(galleryTop) + 'px');
      wrap.style.setProperty('--gallery-pin-extension', Math.round(extension) + 'px');
    }

    window.__cubeflexSyncGalleryPin = syncGalleryPin;
    syncGalleryPin();

    if (!window.__cubeflexGalleryPinBound) {
      window.addEventListener('resize', function () {
        if (window.__cubeflexSyncGalleryPin) window.__cubeflexSyncGalleryPin();
      });
      window.__cubeflexGalleryPinBound = true;
    }
  }

  function reinit() {
    gallery.init();
    initOptions();
    initQuantity();
    initRecommendations();
    initReviews();
    initReviewScroll();
    initReviewPagination();
    initVideo();
    initGalleryPin();
  }

  function reinitProductSection() {
    gallery.init();
    initOptions();
    initQuantity();
    initGalleryPin();
  }

  var configurationCache = {};
  var pendingConfiguration = null;

  function configurationCacheKey(url) {
    var target = new URL(url, window.location.origin);
    target.search = '';
    target.hash = '';
    return target.pathname;
  }

  function primeConfigurationCache() {
    var data = q('#cubeflex-configuration-data');
    if (!data) return;
    try {
      var payloads = JSON.parse(data.textContent);
      Object.keys(payloads).forEach(function (url) {
        var payload = payloads[url];
        if (payload && payload.title && payload.variants && payload.gallery) {
          configurationCache[configurationCacheKey(url)] = payload;
        }
      });
    } catch (error) {
      console.error('Unable to read CubeFlex configuration data.', error);
    }
  }

  function cubeflexPageUrl(url) {
    var target = new URL(url, window.location.origin);
    target.searchParams.set('view', 'cubeflex-1');
    return target.pathname + target.search + target.hash;
  }

  function setConfigurationLoading(isLoading) {
    qa('.config-option button[data-config-url]').forEach(function (button) {
      button.disabled = isLoading;
      button.setAttribute('aria-busy', String(isLoading));
    });
  }

  function fetchConfiguration(url) {
    var key = configurationCacheKey(url);
    if (configurationCache[key]) return Promise.resolve(configurationCache[key]);

    var sep = url.indexOf('?') === -1 ? '?' : '&';
    var fetchUrl = url + sep + 'view=cubeflex-1-config';
    return fetch(fetchUrl, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('bad status');
        return response.json();
      })
      .then(function (payload) {
        if (!payload || !payload.title || !payload.variants || !payload.gallery) throw new Error('invalid configuration payload');
        configurationCache[key] = payload;
        return payload;
      })
      .catch(function () {
        var legacyUrl = cubeflexPageUrl(url);
        return fetch(legacyUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (response) {
            if (!response.ok) throw new Error('bad status');
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var nextSection = doc.querySelector('.cubeflex-product');
            var nextProductSection = nextSection && q('.product-section', nextSection);
            if (!nextProductSection) throw new Error('missing product section');
            var payload = {
              html: nextProductSection.outerHTML,
              title: doc.title
            };
            configurationCache[key] = payload;
            return payload;
          });
      });
  }

  function replaceProductSection(payload) {
    var holder = document.createElement('div');
    holder.innerHTML = payload.html;
    var nextProductSection = q('.product-section', holder);
    var currentProductSection = q('.product-section');
    if (!nextProductSection || !currentProductSection) throw new Error('missing product section');
    currentProductSection.replaceWith(nextProductSection);
    if (payload.title) document.title = payload.title;
    reinitProductSection();
  }

  function applyConfigurationPayload(payload) {
    var title = q('#product-title');
    var galleryMap = q('#cubeflex-gallery-map');
    var select = q('.cubeflex-variant-select');
    var mainImage = q('.main-image img');
    var highlights = q('.product-highlights');
    var priceWrapper = q('[data-price-wrapper]');

    if (title) title.textContent = payload.title;
    if (payload.documentTitle) document.title = payload.documentTitle;
    if (galleryMap) galleryMap.textContent = JSON.stringify(payload.gallery);
    if (mainImage) mainImage.alt = semanticProductAlt(payload.selected.color, payload.selected.material, payload.title);

    var highlightItems = Array.isArray(payload.highlights) ? payload.highlights.filter(Boolean).slice(0, 5) : [];
    if (highlightItems.length) {
      if (!highlights && priceWrapper) {
        highlights = document.createElement('ul');
        highlights.className = 'product-highlights';
        highlights.setAttribute('aria-label', 'Product highlights');
        priceWrapper.insertAdjacentElement('afterend', highlights);
      }
      if (highlights) {
        highlights.innerHTML = '';
        highlightItems.forEach(function (highlight) {
          var item = document.createElement('li');
          item.textContent = highlight;
          highlights.appendChild(item);
        });
        highlights.hidden = false;
      }
    } else if (highlights) {
      highlights.innerHTML = '';
      highlights.hidden = true;
    }

    rebuildProductOptions(payload);

    if (select) {
      select.innerHTML = '';
      payload.variants.forEach(function (variant) {
        var option = document.createElement('option');
        option.value = String(variant.id);
        option.selected = String(variant.id) === String(payload.selected.id);
        option.setAttribute('data-price', variant.price || '');
        option.setAttribute('data-price-cents', variant.priceCents == null ? '' : String(variant.priceCents));
        option.setAttribute('data-compare-at-price', variant.compareAtPrice || '');
        option.setAttribute('data-compare-at-price-cents', variant.compareAtPriceCents == null ? '' : String(variant.compareAtPriceCents));
        option.setAttribute('data-option1', variant.option1 || '');
        option.setAttribute('data-option2', variant.option2 || '');
        option.setAttribute('data-option3', variant.option3 || '');
        option.textContent = [variant.option1, variant.option2, variant.option3].filter(Boolean).join(' / ');
        select.appendChild(option);
      });
    }

    if (window.__cubeflexRefreshOptions) window.__cubeflexRefreshOptions();
    if (payload.initialGallery && payload.initialGallery.length) gallery.setImages(payload.initialGallery);
    if (window.__cubeflexSyncGalleryPin) window.__cubeflexSyncGalleryPin();
  }

  function refreshProductExtras(url) {
    var currentSection = q('.shopify-section--cubeflex-extras');
    if (!currentSection || !currentSection.id) return Promise.resolve();

    var sectionId = currentSection.id.replace(/^shopify-section-/, '');
    var target = new URL(url, window.location.origin);
    target.searchParams.set('section_id', sectionId);

    return fetch(target.pathname + target.search, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load product extras');
        return response.text();
      })
      .then(function (html) {
        if (!html.trim()) throw new Error('Empty product extras');
        currentSection.innerHTML = html;

        qa('script', currentSection).forEach(function (oldScript) {
          if ((oldScript.type || '').toLowerCase() === 'application/ld+json') return;
          var newScript = document.createElement('script');
          Array.prototype.forEach.call(oldScript.attributes, function (attribute) {
            newScript.setAttribute(attribute.name, attribute.value);
          });
          newScript.textContent = oldScript.textContent;
          oldScript.replaceWith(newScript);
        });

        initRecommendations();
        initReviews();
        initReviewScroll();
        initReviewPagination();

        if (window.jdgm && typeof window.jdgm.initializeWidgets === 'function') {
          window.jdgm.initializeWidgets();
        }
      })
      .catch(function (error) {
        console.error('Unable to update CubeFlex product extras.', error);
      });
  }

  function navigateProduct(url) {
    var key = configurationCacheKey(url);
    if (pendingConfiguration === key) return;

    pendingConfiguration = key;
    setConfigurationLoading(true);
    fetchConfiguration(url)
      .then(function (payload) {
        if (payload.html) {
          replaceProductSection(payload);
        } else {
          applyConfigurationPayload(payload);
        }
        history.pushState({}, '', cubeflexPageUrl(url));
        var activeVariantSelect = q('.cubeflex-variant-select');
        if (activeVariantSelect) syncVariantUrl(activeVariantSelect.value);
        refreshProductExtras(url);
      })
      .catch(function (error) {
        console.error('Unable to update CubeFlex configuration.', error);
      })
      .finally(function () {
        pendingConfiguration = null;
        setConfigurationLoading(false);
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    primeConfigurationCache();
    gallery.init();
    initOptions();
    initQuantity();
    initRecommendations();
    initReviews();
    initReviewScroll();
    initReviewPagination();
    initVideo();
    initGalleryPin();
  });
})();
